import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { WagnerDeviceFirmware } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, WagnerDeviceFirmware>,
    'queryKey' | 'queryFn'
  >;
}

export const useWagnerDeviceFirmwareRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, WagnerDeviceFirmware>(
    [Entities.WagnerDeviceFirmware, id],
    async () => {
      const { data } = await api.v1AdminWagnerProbesFirmwaresFirmwareIdGet(id)
      return data
    },
    { ...options },
  )
}
